import React, {useContext} from "react";
import {Typography, Space} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import "./style.scss";
// core
import {LayoutContext} from "../../../core/Contexts";
import {IPhonesFiltersRequest} from "../../../core/models/PhonesFilters";
// components
import BookANumberTurboForm from "../../forms/bookANumberTurbo";
// services
import PhoneService from "../../../services/PhoneService";

export default React.memo(function BookANumberTurbo(props: IProps) {
    const contextLayout = useContext(LayoutContext);
    const {t} = useTranslation();

    return (
        <Typography as="div" className="bl-book-a-number-turbo-modal">
            <Space
                size={_.gte(contextLayout?.width ?? 0, 768) ? 40 : 32}
                direction="vertical"
                align="center"
            >
                <Space size={16} direction="vertical" align="center">
                    <Typography
                        size={_.gte(contextLayout?.width ?? 0, 768) ? 24 : 17}
                        level={2}
                        color="#000000"
                    >
                        {t("Турбо-бронь")}
                    </Typography>
                    <Typography as="div" className="text">
                        <Space size={16} direction="vertical" align="center">
                            <Typography as="div" size={14} color="#000">
                                {t(
                                    "Данная кнопка позволяет быстро забронировать номер, без необходимости вносить паспортные данные и номер сим-карты. "
                                )}
                            </Typography>
                            <Typography as="div" size={14} color="#828282">
                                {t("Забронированный номер переместится в раздел ")}
                                <br />
                                <Typography as="span" size={14} color="#642878">
                                    {t("«Мои брони»")}
                                </Typography>
                                {t(
                                    ", где вы сможете внести номер сим-карты и паспортные данные с помощью кнопки редактировать"
                                )}
                            </Typography>
                        </Space>
                    </Typography>
                </Space>
                <BookANumberTurboForm {...props} />
            </Space>
        </Typography>
    );
});

interface IProps {
    phone: number;
    type: number;
    filters?: IPhonesFiltersRequest;
    Service?: PhoneService;
}
